import moduleBanner1 from '../assets/images/cAsset banner module 1.png'
import moduleBanner2 from '../assets/images/cAssset banner module 2.png'
import moduleBanner3 from '../assets/images/cAsset banner module 3.png'
import moduleBanner4 from '../assets/images/cAsset banner module 4.png'
export const data = [
    {
        id: 1,
        comingSoon: false,
        module: "Module 01",
        img: moduleBanner1,
        title: "Introduction to Commodities and TradeFi",
        description: "This module gives an overview of commodities, working of commodity markets, the impact of Covid on the commodity sector, synthetic commodities and the advantages of Defi over Cefi.",
        lessons: [
            {
                index: 0,
                title: "Lesson 1",
                description: " What are commodities?",
                url: "https://s3.ap-south-1.amazonaws.com/academia.comdex.one/videos/module-1/Comdex_Academy_M1_A1_V2.mp4",
                duration: "00.01.04",
                videoDescription: "Commodities are a raw material or primary agricultural product that can be bought and sold, such as Gold, Silver or Oil. Commodities play a huge role in the business sector. Everything we see around us is the product of a manufacturing process that utilizes primary materials.",
            },
            {
                index: 1,
                title: "Lesson 2",
                description: " How do the commodities markets work?",
                url: "https://s3.ap-south-1.amazonaws.com/academia.comdex.one/videos/module-1/Comdex_Academy_M1_A2_V3a.mp4",
                duration: "00.01.00",
                videoDescription: "Commodities market works by connecting buyers & sellers virtually to trade various assets. One can also participate in commodity trading using futures contracts where the buyer promises to pay the agreed- upon sum at the moment of the transaction when the seller delivers the commodity at a pre - decided date in the future.",
            },
            {
                index: 2,
                title: "Lesson 3",
                description: "How did Covid impact the commodities markets?",
                url: "https://s3.ap-south-1.amazonaws.com/academia.comdex.one/videos/module-1/Comdex_Academy_M1_A3_V2.mp4",
                duration: "00.01.16",
                videoDescription: "Aside from widespread volatility, there were several impacts on the physical functioning of the commodity market itself with countries placing restrictions on goods and the credit market that supports the physical commodities market seized up as lenders were reluctant to lend.",
            },
            {
                index: 3,
                title: "Lesson 4",
                description: " What are synthetic commodities?",
                url: "https://s3.ap-south-1.amazonaws.com/academia.comdex.one/videos/module-1/Comdex_Academy_M1_A4_V2.mp4",
                duration: "00.01.09",
                videoDescription: "Synthetic commodities are digital assets that track the price of real world assets. In this way, users of Comdex can gain exposure to the price fluctuations of assets like Gold, Silver and Oil.",
            },
            {
                index: 4,
                title: "Lesson 5",
                description: "Advantages of DeFi over CeFi",
                url: "https://s3.ap-south-1.amazonaws.com/academia.comdex.one/videos/module-1/Comdex_Academy_M1_A5.mp4",
                duration: "00.01.35",
                videoDescription: "Decentralized systems are antifragile with no single points of failure or control. Decentralized systems like Comdex also operate automatically without huge infrastructure or human resources, meaning that they can operate with very small fees.",
            },

        ]
    },
    {
        id: 2,
        comingSoon: false,
        img: moduleBanner2,
        module: "Module 02",
        title: "Introduction to Cosmos & Important Terminologies",
        description: "This module gives an overview of key concepts like Consensus Mechanisms & Proof of Work, Proof of Stake, Cosmos & IBC, Key metrics and Yield. ",
        lessons: [
            {
                index: 0,
                title: "Lesson 1",
                description: "Consensus Mechanisms & Proof of Work",
                url: "https://binaries-comdex.s3.ap-south-1.amazonaws.com/videos/Module_02_Animation_01/Comdex_Academy_M2_A1.mp4",
                duration: "00.01.52",
                videoDescription: "A consensus mechanism is a fault-tolerant mechanism that is used in blockchain systems to achieve the necessary agreement on the record of transactions within a given network. POW is the original consensus mechanism employed by bitcoin & other early crypto currencies.",
            },
            {
                index: 1,
                title: "Lesson 2",
                description: "Proof of stake",
                url: "https://binaries-comdex.s3.ap-south-1.amazonaws.com/videos/Module_02_Animation_02/Comdex_Academy_M2_A2.mp4",
                duration: "00.01.27",
                videoDescription: "Proof-of-stake (POS) is a cryptocurrency consensus mechanism for processing transactions that was created as an alternative to proof-of-work to reduce the computational load & thus energy consumption of the network.",
            },
            {
                index: 2,
                title: "Lesson 3",
                description: "Cosmos & IBC",
                url: "https://binaries-comdex.s3.ap-south-1.amazonaws.com/videos/Module_02_Animation_03/Comdex_Academy_M2_A3.mp4",
                duration: "00.01.40",
                videoDescription: "Cosmos is a POS chain which offers a secure distributed network & low fees.Inter blockchain Communication protocol blockchains can talk to each other. IBC facilitates transport between various sovereign blockchains operating alongside Cosmos.",
            },
            {
                index: 3,
                title: "Lesson 4",
                description: "Understanding key metrics & terms",
                url: "https://binaries-comdex.s3.ap-south-1.amazonaws.com/videos/Module_02_Animation_04/Comdex_Academy_M2_A4.mp4",
                duration: "00.02.06",
                videoDescription: "The video explains certain key terms like TVL, Daily Volume, Circulating Supply, Total Supply, Slippage and Oracle.",
            },
            {
                index: 4,
                title: "Lesson 5",
                description: "Yield",
                url: "https://binaries-comdex.s3.ap-south-1.amazonaws.com/videos/Module_02_Animation_05/Comdex_Academy_M2_A5.mp4",
                duration: "00.02.34",
                videoDescription: "APR is simply the interest rate currently being offered, whilst APY is this rate annualized with compounding, assuming the rate remains unchanged all year & any profits are reinvested.",
            },

        ],

    },
    {
        id: 3,
        img: moduleBanner3,
        comingSoon: true,
        module: "Module 03",
        title: "Understanding Defi, AMM & Stablecoin",
        description: "This module gives an overview of key concepts like Automated Market Maker (AMM), Decentralized Synthetics Exchange and Stable Coins like TerraUSD. This module also contains a video on how to trade on the Comdex platform after which a user will be able to collateralize and mint cAssets.",
        lessons: [
            {
                index: 0,
                title: "Lesson 1",
                description: "What is an Automatic Market Maker (AMM)?",
                url: "https://binaries-comdex.s3.ap-south-1.amazonaws.com/videos/Module_03_Animation_01/Comdex_Academy_M3_V1.mp4",
                duration: "00.01.45",
                videoDescription: "Automated market maker (AMM) or decentralized exchange, is a tool used to facilitate the exchange of liquidity in decentralized finance (DeFi). The video briefly explains how AMM works with the help of an example.",
            },
            {
                index: 1,
                title: "Lesson 2",
                description: "What is a Decentralized Synthetics Exchange?",
                url: "https://binaries-comdex.s3.ap-south-1.amazonaws.com/videos/Module_03_Animation_02/Comdex_Academy_M3_V2.mp4",
                duration: "00.01.22",
                videoDescription: "A decentralized synthetics exchange contains synthetic representations of physical assets rather than purely digital assets. By utilizing synthetics, an investor can take positions in various real world assets in minutes, avoiding barriers to entry associated with the commodities markets.",
            },
            {
                index: 2,
                title: "Lesson 3",
                description: "An introduction to stable coins",
                url: "https://binaries-comdex.s3.ap-south-1.amazonaws.com/videos/Module_03_Animation_03/Comdex_ACademy_M3_V3.mp4",
                duration: "00.01.28",
                videoDescription: "Stablecoins are digital tokens that are pegged to the value of a real world currency such as the United States Dollar. Comdex has chosen to utilize the Terra stablecoin (UST). TerraUSD was created to deliver value to offer a scalable solution for DeFi amid severe scalability problems faced by other stablecoin leaders like Dai.",
            },
        ],

    },
    {
        id: 4,
        img: moduleBanner4,
        comingSoon: true,
        module: "Module 04",
        title: " Complete Walkthrough of Decentralised Synthetics Exchange ",
        description: "Through this video, users will be able to trade on the Comdex platform. The video explains the process to connect wallet, mint cAssets, provide liquidity and other additional features of the Comdex platform",
        lessons: [
            {
                index: 0,
                title: "Lesson 1",
                description: "Lorem Ipsum",
                url: "https://s3.ap-south-1.amazonaws.com/academia.comdex.one/videos/module-1/Comdex_Academy_M1_A1_V2.mp4",
                duration: "00.01.04",
                videoDescription: "",
            }],

    },

]